import React, { useState, useEffect, useContext, useRef } from "react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

import { MyContext } from "../../PageRouters/layouts/publicLayout";

const AudioPlayerComponent = (props) => {
  // console.log("audioprops", props)

  const [state, setState] = useState({
    volume: Math.min(
      1,
      Math.max(0, Number(localStorage.getItem("volumeValue") || 1))
    ),
    isMuted: localStorage.getItem("mutedState") === "true" || false,
    audioFile: props.data,
    audioIndex: 0,
    loop: false,
  });
  const userOnlineDurationTime = Number(
    localStorage.getItem("userOnlineDuration")
  );
  const [lastLoggedMinute, setLastLoggedMinute] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);
  const { isMuted, loop, volume } = state;

  const context = useContext(MyContext);

  const onChangeNext = () => {
    if (
      context?.audioFiles[context?.playSongIndex]?.song
        ? context?.audioFiles[context?.playSongIndex]?.song
        : "" === ""
    ) {
      setState({ ...state, loop: true });
      return;
    }

    if (context?.playSongIndex !== context?.playSongIndex.length - 1) {
      setState((prevState) => ({
        ...prevState,
        audioIndex: state.audioIndex + 1,
      }));
      let value = context?.playSongIndex + 1;
      context.setplaySongIndex(value);
    }
    if (context?.playSongIndex === context?.playSongIndex.length - 1) {
      setState((prevState) => ({
        ...prevState,
        audioIndex: 0,
      }));
      let value = context?.playSongIndex - 1;
      context.setplaySongIndex(value);
    }
  };

  const onChangePrev = () => {
    if (context?.playSongIndex === 0) {
      setState((prevState) => ({
        ...prevState,
        audioIndex: 0,
      }));
      context.setplaySongIndex(0);
    } else {
      setState((prevState) => ({
        ...prevState,
        audioIndex: state.audioIndex - 1,
      }));
      let value = context?.playSongIndex - 1;
      context.setplaySongIndex(value);
    }
  };
  const handleVolume = (e) => {
    if (e.target.volume === 0) {
      localStorage.setItem("volumeValue", 0);
      localStorage.setItem("mutedState", true);
    } else if (e.target.volume === 1) {
      localStorage.setItem("volumeValue", 1);
      localStorage.setItem("mutedState", false);
    } else {
      localStorage.setItem("mutedState", false);
      localStorage.setItem(
        "volumeValue",
        parseFloat(e.target.volume).toFixed(2)
      );
    }
  };

  // Called every 60 seconds while playing
  useEffect(() => {
    return () => {
      if (
        isPlaying &&
        context.audioFiles[context.playSongIndex]?.isradio === true &&
        window._paq
      ) {
        window._paq.push(["deleteCustomVariable", 1, "visit"]);
        window._paq.push(["trackPageView"]);
        window._paq.push(["trackEvent", "Audio", "Heartbeat", "Stop"]);
      }
    };
  }, [isPlaying]);
  const handleListen = (currentTime) => {
    const elapsedSeconds = Math.floor(currentTime);
    if (isPlaying && elapsedSeconds === 1 && window._paq) {
      window._paq.push([
        "setCustomVariable",
        1,
        "viewerStatus",
        props?.tittle ? `watching-${props.tittle}` : "watching",
        "visit",
      ]);
      window._paq.push(["trackEvent", "Audio", "Heartbeat", "Playing"]);
      window._paq.push(["trackPageView"]);
    }
    if (
      isPlaying &&
      elapsedSeconds > 0 &&
      elapsedSeconds % userOnlineDurationTime === 0
    ) {
      if (lastLoggedMinute !== elapsedSeconds) {
        if (window._paq) {
          window._paq.push([
            "setCustomVariable",
            1,
            "viewerStatus",
            props?.tittle ? `watching-${props.tittle}` : "watching",
            "visit",
          ]);
          window._paq.push(["trackEvent", "Audio", "Heartbeat", "Playing"]);
          window._paq.push(["trackPageView"]);
        }
        setLastLoggedMinute(elapsedSeconds);
      }
    }
    // if(isPlaying && elapsedSeconds===)
  };
  const handleEnded = () => {
    onChangeNext();
    props.nextSong(context?.playSongIndex ? context?.playSongIndex : 0);
    setIsPlaying(false);
    if (
      context.audioFiles[context.playSongIndex]?.isradio === true &&
      window._paq
    ) {
      window._paq.push(["deleteCustomVariable", 1, "visit"]);
      window._paq.push(["trackPageView"]);
      window._paq.push(["trackEvent", "Audio", "Heartbeat", "Stop"]);
    }
  };
  // useEffect(() => {

  // }, [context.playSongIndex])

  // console.log("abhi", context?.audioFiles[context?.playSongIndex]?.song ? context?.audioFiles[context?.playSongIndex]?.song : '')

  return (
    <AudioPlayer
      autoPlay
      showSkipControls={true}
      autoPlayAfterSrcChange={true}
      src={context?.audioFiles[context?.playSongIndex]?.song ? context?.audioFiles[context?.playSongIndex]?.song : ''}
      showJumpControls={false}
      loop={loop}
      //muted={state.isMutedRadioPlayer}
      muted={isMuted}
      volume={volume}
      onVolumeChange={(e) => handleVolume(e)}
      onPlay={(e) => setIsPlaying(true)}
      onClickPrevious={(e) => {
        onChangePrev();
        props.prevSong(context?.playSongIndex ? context?.playSongIndex : 0);
      }}
      onClickNext={(e) => {
        onChangeNext();
        props.nextSong(context?.playSongIndex ? context?.playSongIndex : 0);
      }}
      onEnded={() => handleEnded()}
      onListen={(e) => handleListen(e.target.currentTime)}
      // other props here
    />
  );
};

export default AudioPlayerComponent;
